import React from "react";
import { IonItem, IonLabel, IonIcon, IonButton, useIonAlert } from "@ionic/react";
import { checkmarkCircle, shareOutline, closeCircle } from "ionicons/icons";
import { Invitation } from "@core/types";
import { formatPhoneNumber } from "../CustomPhoneInput/phoneUtils";

import { showSharingOptions } from "../../utils/shareApp";
import { useConfig } from "../../providers/config";
import { useTranslation } from "react-i18next";
interface InviteeListItemProps {
  invitee: Invitation;
  onRemove: (inviteeId: string) => void;
}

const InviteeListItem: React.FC<InviteeListItemProps> = ({ invitee, onRemove }) => {
  const { t } = useTranslation();
  const isActive = invitee.status === "active";
  const [presentAlert] = useIonAlert();
  const config = useConfig();

  const handleShowSharingOptions = () => {
    showSharingOptions(invitee.invitee_phone, config, t, presentAlert);
  };

  return (
    <IonItem>
      <IonLabel>{formatPhoneNumber(invitee.invitee_phone)}</IonLabel>
      <div className="ion-no-margin ion-no-padding" style={{ display: "flex", alignItems: "center" }}>
        {isActive ? (
          <IonButton fill="clear">
            <IonIcon icon={checkmarkCircle} color="success" />
          </IonButton>
        ) : (
          <IonButton fill="clear" onClick={handleShowSharingOptions}>
            <IonIcon icon={shareOutline} color="primary" />
          </IonButton>
        )}
        <IonButton
          fill="clear"
          onClick={() => onRemove(invitee.id)}
          disabled={isActive}
          style={{ opacity: isActive ? 0.5 : 1 }}
        >
          <IonIcon icon={closeCircle} color="danger" />
        </IonButton>
      </div>
    </IonItem>
  );
};

export default InviteeListItem;
